/* global define, module, root */
(function (root, factory) {
    "use strict";
    if (typeof exports === "object") {
        // CommonJS
        module.exports = factory();
    } else if (typeof define === "function" && define.amd) {
        // AMD. Register as an anonymous module.
        define([], factory);
    } else {
        // Browser globals
        root.bemSelector = factory();
    }
})
(this, function() {
"use strict";

var defaults = {
    elementSeperator: "__",
    modSeperator: "--",
    modValueSeperator: "-",
    classSeperator: " "
};

 function BemSelector(options){
    // Case call BemFormatter() without new
    if (!(this instanceof BemSelector)) {
        return getBemSelectorInstance(options);
    }

    options = options || {};
    this.elementSeperator = options.elementSeperator || defaults.elementSeperator;
    this.modSeperator = options.modSeperator || defaults.modSeperator;
    this.modValueSeperator = options.modValueSeperator || defaults.modValueSeperator;
    this.classSeperator = options.classSeperator || defaults.classSeperator;

 }

 BemSelector.prototype = {

    _createModifier: function(base, modifierKey, modifierValue){
        if (typeof modifierValue === "boolean" && modifierValue){
            return base + this.modSeperator + modifierKey;
        }
        else {
            return base + this.modSeperator + modifierKey + this.modValueSeperator + modifierValue;
        }
    },
    _generateModifiers: function(base, modifiersList){
        modifiersList = modifiersList || {};
        var modifierClassString = "";
        Object.getOwnPropertyNames(modifiersList).forEach(function(modifier){
            modifierClassString += this.classSeperator + this._createModifier(base, modifier, modifiersList[modifier]);
        }.bind(this));
        return modifierClassString;
    },
    _generateElement: function(base, el, generatedElementsObject) {
        var elementName = base + this.elementSeperator + el.name;
        Object.defineProperty(generatedElementsObject, el.name, {
            value: elementName +  this._generateModifiers(elementName, el.modifiers)
        });
        return generatedElementsObject;
    },
    _generateElementList: function(base, elementList){
        var generatedElementsObject = {};
       if (elementList) {
         elementList.forEach(function(el){
           generatedElementsObject = this._generateElement(base, el, generatedElementsObject);
         }.bind(this));
       }
     
       return generatedElementsObject;
    },
    _generateBlockName: function(b){
        return b.name + this._generateModifiers(b.name, b.modifiers);
    },

    generateBemBlock: function(bemBlock){
        var b = bemBlock;
        if (bemBlock.children) {
            var bemBlockResult = {
                name: this._generateBlockName(b),
                children: this._generateElementList(b.name, b.children)
            };
        }
        else {
          bemBlockResult = this._generateBlockName(b);
        }
        return bemBlockResult;
    }
 };

 function getBemSelectorInstance(options) {
    var bemSelector = new BemSelector(options);
    var b = bemSelector.generateBemBlock.bind(bemSelector);
    return b;
 }

 var b = getBemSelectorInstance();
 b.config = BemSelector;
 return b;
});



//////////////////
// WEBPACK FOOTER
// ./~/bem-selector/src/bemSelector.js
// module id = 776
// module chunks = 29